import { useRef, useState } from 'react'
import { WantListItem } from 'widgets/WantListItem/ui/WantListItem'
import {
    addMomentPin,
    moveMomentToAccepted,
    moveMomentToRejected,
    moveMomentToWanted,
    removeMomentPin,
} from 'features/anonymousAuth'
import { useDispatch, useSelector } from 'react-redux'
import cls from './WantContainer.module.scss'
import { getPinnedMoments } from 'features/anonymousAuth/model/selectors/getSelectors'
import {
    getOtherPinnedCardData,
    getPinnedCardData,
} from 'app/providers/LoadDataProvider/ui/selectors'
import {
    Text,
    TextAlign,
    TextColor,
    TextSize,
    TextWeight,
} from 'shared/ui/Text/Text'
import { EmptyWantContainer } from '../EmptyWantContainer/EmptyWantContainer'
import { Credits } from 'widgets/Credits/Credits'
import { BottomButton } from './BottomButton/BottomButton'
import React from 'react'
import { PinIcon } from 'shared/ui/Icon'

const sameId = (left, right) => String(left) === String(right)

const groupCardsByDate = (cards, excludedCards) => {
    const excludedIds = new Set(excludedCards.map((item) => item.id))
    const todayCollection = []
    const yesterdayCollection = []
    const weekCollection = []
    const monthCollection = []
    const laterCollection = []
    const finalCollection = []

    const now = new Date()
    const yesterday = new Date(now)
    yesterday.setDate(yesterday.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0)

    const startOfToday = new Date(now)
    startOfToday.setHours(0, 0, 0, 0)

    const startOfWeek = new Date(now)
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay())
    startOfWeek.setHours(0, 0, 0, 0)

    const startOfMonth = new Date(
        now.getFullYear(),
        now.getMonth(),
        1,
        0,
        0,
        0,
        0
    )

    cards.forEach((item) => {
        if (excludedIds.has(item.id)) return

        const time = new Date(item.time)
        if (time >= startOfToday) {
            todayCollection.push(item)
        } else if (time >= yesterday) {
            yesterdayCollection.push(item)
        } else if (time >= startOfWeek) {
            weekCollection.push(item)
        } else if (time >= startOfMonth) {
            monthCollection.push(item)
        } else {
            laterCollection.push(item)
        }
    })

    if (todayCollection.length > 0)
        finalCollection.push('Сегодня', ...todayCollection)
    if (yesterdayCollection.length > 0)
        finalCollection.push('Вчера', ...yesterdayCollection)
    if (weekCollection.length > 0)
        finalCollection.push('На этой неделе', ...weekCollection)
    if (monthCollection.length > 0)
        finalCollection.push('В этом месяце', ...monthCollection)
    if (laterCollection.length > 0)
        finalCollection.push('Ранее', ...laterCollection)

    finalCollection.sort((a, b) => b.time - a.time)
    return finalCollection
}

export const WantContainer = (props) => {
    const { readonly, wantedCardData, myAllMoments } = props
    const dispatch = useDispatch()
    const pinnedMoments = useSelector(getPinnedMoments)
    const pinnedCardData = useSelector(getPinnedCardData)
    const otherPinnedCardData = useSelector(getOtherPinnedCardData)

    const excludedCards = readonly ? otherPinnedCardData : pinnedMoments
    const [wantedData, setWantedData] = useState(() =>
        groupCardsByDate(wantedCardData, excludedCards)
    )
    const [pinnedData, setPinnedData] = useState(() =>
        readonly ? otherPinnedCardData : pinnedCardData
    )

    const intersectRef = useRef(null)

    // пагинация
    // useEffect(() => {
    //     const options = {
    //         rootMargin: "0px",
    //         thresHold: 0.3
    //     }

    //     const observer = new IntersectionObserver((entries, observer) => {
    //         if (entries[0].isIntersecting && pagArr.length > 0) {
    //             console.log('пересечен')
    //             console.log(pagArr)
    //             setWantedData([...wantedData, ...pagArr])
    //         }
    //     }, options)
    //     if (intersectRef.current) observer.observe(intersectRef.current)

    //     return () => {
    //         if (intersectRef.current) observer.unobserve(intersectRef.current)
    //     }
    // }, [pagArr])

    const toAcceptedMoment = async (id) => {
        const outcome = await dispatch(moveMomentToAccepted(id))
        if (!outcome.applied) return

        setWantedData([...wantedData.filter((item) => item.id !== id)])
        setPinnedData([...pinnedData.filter((item) => item.id !== id)])
        // setPagArr([...pagArr.filter((item) => item.id !== id)])
    }

    const toWantedMoment = async (id) => {
        const outcome = await dispatch(moveMomentToWanted(id))
        if (!outcome.applied) return

        if (pinnedData.find((item) => sameId(item.id, id))) {
            setPinnedData((items) =>
                items.map((item) =>
                    sameId(item.id, id)
                        ? { ...item, comparison: 'wanted' }
                        : item
                )
            )
        } else {
            setWantedData((items) =>
                items.map((item) =>
                    sameId(item.id, id)
                        ? { ...item, comparison: 'wanted' }
                        : item
                )
            )
        }
        // setWantedData(newWantedData)
        // console.log(newWantedData)
    }

    // const settingsClick = (e, id) => {
    //     if (pinnedMoments.includes(id)) {
    //         setIsPinned(true)
    //     } else {
    //         setIsPinned(false)
    //     }
    //     const element = e.target.getBoundingClientRect()
    //     // setY(element.y + 340)
    //     console.log(id)
    //     setCardId(id)
    // }

    // const onCloseSettings = () => {
    //     setY(0)
    // }

    const toRejectedMoment = async (id) => {
        const outcome = await dispatch(moveMomentToRejected(id))
        if (!outcome.applied) return

        setWantedData([...wantedData.filter((item) => item.id !== id)])
        setPinnedData([...pinnedData.filter((item) => item.id !== id)])
        // setPagArr([...pagArr.filter((item) => item.id !== id)])
    }

    const toPinnedMoment = async (id) => {
        const card = wantedData.find((item) => sameId(item.id, id))
        const outcome = await dispatch(addMomentPin(id))
        if (!outcome.applied) return

        setPinnedData(card ? [card, ...pinnedData] : pinnedData)
        setWantedData([...wantedData.filter((item) => item.id !== id)])
        // setPagArr([...pagArr.filter((item) => item.id !== id)])
    }

    const fromPinnedMoment = async (id) => {
        const card = pinnedData.find((item) => sameId(item.id, id))
        const outcome = await dispatch(removeMomentPin(id))
        if (!outcome.applied) return

        setPinnedData([...pinnedData.filter((item) => item.id !== id)])
        if (card) {
            setWantedData([...wantedData, card].sort((a, b) => b.time - a.time))
        }
    }

    return (
        <div className={cls.WantContainer}>
            {wantedData.length !== 0 || pinnedData.length !== 0 ? (
                <>
                    {pinnedData.length ? (
                        <Text
                            weight={TextWeight.SBOLD}
                            color={TextColor.TERBLACK}
                            align={TextAlign.LEFT}
                            size={TextSize.S}
                            className={cls.Pinned}
                        >
                            <div className={cls.PinnedTextWrapper}>
                                Закреплено
                                <PinIcon className={cls.Icon} />
                            </div>
                        </Text>
                    ) : null}
                    {/* {transitionsForPinned((style, item) => {
                    return (
                        <WantListItem
                            style={style}
                            key={item.id}
                            text={item.text}
                            img={item.img}
                            id={item.id}
                            comparison={item.comparison}
                            toAcceptedMoment={toAcceptedMoment}
                            toWantedMoment={toWantedMoment}
                            settingsClick={settingsClick}
                            readonly={readonly}
                        />
                    )
                })} */}
                    {pinnedData.map((item) => {
                        return (
                            <WantListItem
                                pinned={true}
                                key={item.id}
                                text={item.text}
                                img={item.img}
                                id={item.id}
                                comparison={item.comparison}
                                toAcceptedMoment={toAcceptedMoment}
                                toWantedMoment={toWantedMoment}
                                // settingsClick={settingsClick}
                                fromPinnedMoment={fromPinnedMoment}
                                toRejectedMoment={toRejectedMoment}
                                readonly={readonly}
                            />
                        )
                    })}
                    {/* {transitions((style, item) => {
                    if (typeof (item) === "string") {
                        return (
                            <Text
                                weight={TextWeight.SBOLD}
                                color={TextColor.TERBLACK}
                                align={TextAlign.LEFT}
                                size={TextSize.S}
                                className={cls.Pinned}
                            >
                                {item}
                            </Text>
                        )
                    } else {
                        return (
                            <WantListItem
                                readonly={readonly}
                                style={style}
                                key={item.id}
                                text={item.text}
                                img={item.img}
                                id={item.id}
                                comparison={item.comparison}
                                toAcceptedMoment={toAcceptedMoment}
                                toWantedMoment={toWantedMoment}
                                settingsClick={settingsClick}
                            />
                        )
                    }
                })} */}
                    {wantedData.map((item) => {
                        if (typeof item === 'string') {
                            return (
                                <Text
                                    weight={TextWeight.SBOLD}
                                    color={TextColor.TERBLACK}
                                    align={TextAlign.LEFT}
                                    size={TextSize.S}
                                    className={cls.Pinned}
                                    key={item}
                                >
                                    {item}
                                </Text>
                            )
                        } else {
                            return (
                                <WantListItem
                                    readonly={readonly}
                                    // style={style}
                                    key={item.id}
                                    text={item.text}
                                    img={item.img}
                                    id={item.id}
                                    comparison={item.comparison}
                                    toAcceptedMoment={toAcceptedMoment}
                                    toWantedMoment={toWantedMoment}
                                    // settingsClick={settingsClick}
                                    toRejectedMoment={toRejectedMoment}
                                    toPinnedMoment={toPinnedMoment}
                                    fromPinnedMoment={fromPinnedMoment}
                                />
                            )
                        }
                    })}
                    <div
                        style={{ height: '30px', width: '100%' }}
                        ref={intersectRef}
                    />
                    <BottomButton readonly={readonly} />
                    <Credits
                        mode={readonly ? 'short' : null}
                        style={
                            myAllMoments.length === 0 && readonly
                                ? { marginBottom: '76px' }
                                : null
                        }
                    />
                </>
            ) : (
                <>
                    <EmptyWantContainer readonly={readonly} />
                    <Credits
                        className={readonly ? cls.CreditsShort : null}
                        mode={readonly ? 'short' : null}
                        style={
                            myAllMoments.length === 0 && readonly
                                ? { marginBottom: '76px' }
                                : null
                        }
                    />
                </>
            )}
        </div>
    )
}
